export default __webpack_public_path__ + "static/videoSupervisionCustomerWaiting-baaa023643ea5f7033e606af1ff3af7e.mp3";